import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../service/login.service';
import { Login } from '../models/login.interface';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  public show: boolean = false;
  public loginForm: FormGroup;
  public errorMessage: any;
  mostrar: boolean = true;
  mostrarLoader: boolean = false;

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private authService: LoginService) {
    this.loginForm = this.fb.group({
      nombre: ['', Validators.required],
      apellido: ['', Validators.required],
      tipodoc: ['DNI', Validators.required],
      nrodoc: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit() {
  }

  showPassword() {
    this.show = !this.show;
  }

  onInputChange(event: any): void {
    const input = event.target.value;
    event.target.value = input.replace(/[^0-9]/g, '');
  }

  register() {
    // Obtener valores del formulario
    const apellido = this.loginForm.value.apellido?.trim() || '';
    const nombre = this.loginForm.value.nombre?.trim() || '';
    const nombreCompleto = `${apellido} ${nombre}`; // Crear nombre completo

    // Crear un objeto de registro con los valores necesarios
    const registro = {
      ...this.loginForm.value, // Copiar todos los valores del formulario
      nombre: nombreCompleto // Sobrescribir el campo 'nombre' con el nombre completo
    };

    this.mostrar = false;
    this.mostrarLoader = true;
    // Llamar al servicio con el objeto de registro
    this.authService.register(registro).subscribe((resp) => {
      if (resp.isSuccess) {
        const login: Login = {
          username: this.loginForm.value.username,
          password: this.loginForm.value.password
        };
        this.mostrarLoader = false;

        this.authService.login(login).subscribe((resp) => {
          if (resp.isSuccess) {
            this.router.navigate(['/menu/mis-datos']);
          }
        });
      } else {
        this.mostrar = true;
      }
    });
  }

}
